import { CUSTOM_FIELD_PREFIX } from 'components/forms/inputs/custom-fields/customFieldPrefix';

/**
 * The record as last fetched with one section's edited values in place: the fields `sectionFields` lists for the
 * section, or every custom field for `custom-fields`. A section save sends this, so it never changes a field of
 * another section, even one the section's handlers set.
 */
export const mergeSectionValues = <Form extends object, Section extends string>(
    latest: Form,
    edited: Form,
    section: Section,
    sectionFields: Record<Section, readonly string[]>
): Form => {
    const values = edited as unknown as Record<string, unknown>;
    const fields =
        section === 'custom-fields'
            ? Object.keys(values).filter((field) => field.startsWith(CUSTOM_FIELD_PREFIX))
            : sectionFields[section];
    return { ...latest, ...Object.fromEntries(fields.map((field) => [field, values[field]])) };
};
